import i18next from 'i18n/config';

import { BOOK_TYPE_ID } from '@common/constants/BookTypeId';

import { IBookTab } from '../types/tab';

const BooksTabs: IBookTab[] = [
	{ title: i18next.t('tabs.books'), book_type_id: BOOK_TYPE_ID.EDUCATION },
	{ title: i18next.t('tabs.materials'), book_type_id: BOOK_TYPE_ID.FICTION },
];

i18next.on('languageChanged', () => {
	BooksTabs[0].title = i18next.t('tabs.books');
	BooksTabs[1].title = i18next.t('tabs.materials');
});

export default BooksTabs;
